<app-block-wrapper [_editable]="_editable" [style]="style">
  <a class="post pinned" [routerLink]="'/' + pinnedPost.full_slug">
    <div class="post-image" [style.background-image]="'url(' + pinnedPost.content.keyVisual?.filename + ')'"></div>
    <div class="post-content">
      <h2>{{ pinnedPost | pageTitle }}</h2>
      <div class="post-lead">
        <div>{{ pinnedPost | pageDescription }}</div>
      </div>
      <span class="date">{{ pinnedPost.published_at | date }}</span>
    </div>
  </a>
</app-block-wrapper>
